import { gql } from '@apollo/client';
import { genericFields } from './index';

export const itemsFragment = gql`
  fragment itemFields on ESItem {
    ${genericFields}
    isBusiness
    photos(limit: 4) {
      thumbnail
      f460x345
      large
    }
  }
`;
